<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i"></a><a id="halftitle"></a><em>S<span class="small">OLVING</span> T<span class="small">OUGH</span> P<span class="small">ROBLEMS</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?1f11fe90